<script lang="ts">
  import Nav from '$lib/components/Nav.svelte';
  import Footer from '$lib/components/Footer.svelte';
</script>

<div class="min-h-screen bg-white">
  <Nav />
  
  <div class="max-w-3xl mx-auto px-8 py-16">
    <h1 class="text-3xl font-light mb-8">Imprint</h1>
    
    <div class="prose prose-lg">
      <h3>Information according to § 5 TMG</h3>
      <p class="text-sm mt-2 mb-6">
        Jonas Loh<br />
        Studio NAND<br />
        Sophienstraße 18<br />
        10178 Berlin<br />
        Germany
      </p>

      <h3>Contact</h3>
      <p class="text-sm mt-2 mb-6">
        Email: mail[at]jonas-loh.com<br />
      </p>

      <h3>EU Dispute Resolution</h3>
      <p class="text-sm mt-2 mb-6">
        The European Commission provides a platform for online dispute resolution (OS) which is available at 
        <a href="https://ec.europa.eu/consumers/odr/" class="text-accent-color hover:underline">https://ec.europa.eu/consumers/odr/</a>.
      </p>

      <h3>Consumer dispute resolution/Universal arbitration board</h3>
      <p class="text-sm mt-2 mb-6">
        We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.
      </p>

      <h3>Liability for Contents</h3>
      <p class="text-sm mt-2 mb-6">
        As service providers, we are liable for own contents of these websites according to § 7, paragraph 1 German TMG (Telemediengesetz) and general laws. However, according to §§ 8 to 10 German TMG, service providers are not obligated to permanently monitor submitted or stored information or to search for evidences that indicate illegal activities.
      </p>
      <p class="text-sm mt-2 mb-6">
        Legal obligations to removing information or to blocking the use of information remain unchallenged. In this case, liability is only possible at the time of knowledge about a specific violation of law. Illegal contents will be removed immediately at the time we get knowledge of them.
      </p>

      <h3>Liability for Links</h3>
      <p class="text-sm mt-2 mb-6">
        Our offer includes links to external third party websites. We have no influence on the contents of those websites, therefore we cannot guarantee for those contents. Providers or administrators of linked websites are always responsible for their own contents.
      </p>
      <p class="text-sm mt-2 mb-6">
        The linked websites had been checked for possible violations of law at the time of the establishment of the link. Illegal contents were not detected at the time of the linking. A permanent monitoring of the contents of linked websites cannot be imposed without reasonable indications that there has been a violation of law. Illegal links will be removed immediately at the time we get knowledge of them.
      </p>

      <h3>Copyright</h3>
      <p class="text-sm mt-2 mb-6">
        Contents and compilations published on these websites by the providers are subject to German copyright laws. Reproduction, editing, distribution as well as the use of any kind outside the scope of the copyright law require a written permission of the author or originator. Downloads and copies of these websites are permitted for private use only.
      </p>
      <p class="text-sm mt-2 mb-6">
        The commercial use of our contents without permission of the originator is prohibited.
      </p>
      <p class="text-sm mt-2 mb-6">
        Copyright laws of third parties are respected as long as the contents on these websites do not originate from the provider. Contributions of third parties on this site are indicated as such. However, if you notice any violations of copyright law, please inform us. Such contents will be removed immediately.
      </p>
    </div>
  </div>

  <Footer />
</div> 